import { Box } from '@mui/material';
import React from 'react';

const WalletIcon = ({ ...rest }) => (
  <Box {...rest}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.6667 26H18.6667C17.5733 26 16.6667 25.0933 16.6667 24C16.6667 22.9067 17.5733 22 18.6667 22H34.6667C35.76 22 36.6667 22.9067 36.6667 24C36.6667 25.0933 35.76 26 34.6667 26Z"
        fill="white"
      />
      <path
        d="M50.7731 39.4673C46.7464 39.4673 43.3331 36.4806 43.0131 32.6406C42.7997 30.4273 43.5997 28.2673 45.1997 26.6939C46.5331 25.3072 48.4264 24.5339 50.4264 24.5339H55.9997C58.6397 24.6139 60.6664 26.6939 60.6664 29.2539V34.7473C60.6664 37.3073 58.6397 39.3873 56.0797 39.4673H50.7731ZM55.9197 28.5339H50.4531C49.5197 28.5339 48.6664 28.8806 48.0531 29.5206C47.2797 30.2673 46.9064 31.2806 47.0131 32.2939C47.1464 34.0539 48.8531 35.4673 50.7731 35.4673H55.9997C56.3464 35.4673 56.6664 35.1473 56.6664 34.7473V29.2539C56.6664 28.8539 56.3464 28.5606 55.9197 28.5339Z"
        fill="white"
      />
      <path
        d="M42.6667 56.6666H18.6667C9.49333 56.6666 3.33333 50.5066 3.33333 41.3332V22.6666C3.33333 14.4533 8.39994 8.50661 16.2666 7.51995C16.9866 7.41328 17.8133 7.33325 18.6667 7.33325H42.6667C43.3067 7.33325 44.1333 7.35992 44.9867 7.49325C52.8533 8.39992 58 14.3733 58 22.6666V26.5333C58 27.6266 57.0933 28.5333 56 28.5333H50.4533C49.52 28.5333 48.6667 28.8799 48.0533 29.5199L48.0267 29.5466C47.28 30.2666 46.9333 31.2533 47.0133 32.2666C47.1467 34.0266 48.8533 35.4399 50.7733 35.4399H56C57.0933 35.4399 58 36.3466 58 37.4399V41.3066C58 50.5066 51.84 56.6666 42.6667 56.6666ZM18.6667 11.3333C18.0267 11.3333 17.4133 11.3866 16.8 11.4666C10.9333 12.2132 7.33333 16.4799 7.33333 22.6666V41.3332C7.33333 48.2132 11.7867 52.6666 18.6667 52.6666H42.6667C49.5467 52.6666 54 48.2132 54 41.3332V39.4666H50.7733C46.7467 39.4666 43.3333 36.4799 43.0133 32.6399C42.8 30.4532 43.6 28.2666 45.2 26.7199C46.5867 25.3066 48.4533 24.5333 50.4533 24.5333H54V22.6666C54 16.4266 50.3467 12.1332 44.4267 11.4399C43.7867 11.3332 43.2267 11.3333 42.6667 11.3333H18.6667Z"
        fill="white"
      />
    </svg>
  </Box>
);

export default WalletIcon;
